require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/fn/object/keys.js
// module id = 892
// module chunks = 0